import { ProductDescriptionAccordionThemeInterface } from './types'

export const theme: ProductDescriptionAccordionThemeInterface = {
  defaultItemsOpen: 1,
}
